import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { ContractContext } from '@/hooks/api/models';

/**
 * 0760. 契約タイプ一覧
 * [GET] /contract_contexts
 */
const contractContexts = (): Promise<ContractContext[]> => {
  return axios.get(`/api/contract_contexts`);
};

export const useContractContexts = () => {
  return useQuery({
    queryKey: ['contract_contexts'],
    queryFn: () => contractContexts(),
  });
};
